import { combineReducers } from "redux";
import TopBarHeaderText from "./reducer_pages";

const rootReducer = combineReducers({
  pages: TopBarHeaderText
});

export default rootReducer;
